import {
  isString,
  isObject,
  isArray,
  hasProperty,
  stripTags,
  truncate,
} from "bellajs";
import { decode } from "html-entities";
import { XMLValidator, XMLParser } from "fast-xml-parser";

export interface ApiResponse {
  status: string;
  feed: {
    url: string;
    title: string;
    link: string;
    author: string;
    description: string;
    image: string;
  };
  entries: {
    title: string;
    published: string;
    link: string;
    guid: string;
    author: string;
    thumbnail: string;
    description: string;
    content: string;
    enclosure: {
      link: string;
      type: string;
      thumbnail: string;
    };
    categories: string[];
  }[];
}

export interface ApiEntriesResponse {
  title: string;
  published: string;
  link: string;
  guid: string;
  author: string;
  thumbnail: string;
  description: string;
  content: string;
  enclosure: {
    link: string;
    type: string;
    thumbnail: string;
  };
  categories: string[];
}

export interface VideoInterface {
  id: string;
  title: string;
  link: string;
  isShorts: boolean;
  pubDate: string;
  description: string;
  internalLink: string;
  hqVideoThumbnail: string;
  videoThumbnail: string;
}

export const videos: VideoInterface[] = [
  {
    id: "",
    title: "",
    link: "",
    isShorts: false,
    pubDate: "",
    description: "",
    internalLink: "",
    hqVideoThumbnail: "",
    videoThumbnail: ""
  },
];

export const initialStateApiResponse: ApiEntriesResponse[] = [
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
  {
    title: "",
    published: "",
    link: "showLoadingPlaceholder",
    guid: "",
    author: "",
    thumbnail: "",
    description: "",
    content: "",
    enclosure: { link: "", type: "", thumbnail: "" },
    categories: [""],
  },
];

export interface IVideos {
  title: string;
  pubDate: string;
  link: string;
  guid: string;
  author: string;
  thumbnail: string;
  description: string;
  content: string;
  enclosure: {
    link: string;
    type: string;
    thumbnail: string;
  };
  categories: string[];
}

export interface IVideoInfo {
  id: string;
  title: string;
  link: string;
  isShorts: boolean;
  pubDate: string;
  description: string;
  internalLink: string;
  shortsThumbnail: string;
  videoThumbnail: string;
}

export interface LocalVideosList {
  videoID: string;
  title: string;
  pubDate: string;
  link: string;
  thumbnail: string;
  description: string;
}

/* export const swe1r_hd4k_videos_list: VideoInterface[] = [
  {
    id: "b96wr913c5c",
    title: "SWE1R HD Comparison | 4k@60fps to Original 272p@15fps",
    link: "https://www.youtube.com/watch?v=b96wr913c5c",
    isShorts: false,
    pubDate: "2020-07-04",
    description: "",
    internalLink: "/b96wr913c5c/",
    shortsThumbnail: "",
    videoThumbnail: "https://i3.ytimg.com/vi/b96wr913c5c/hqdefault.jpg",
  },
  {
    id: "0P8FdrU_UQs",
    title: "STAR WARS EPISODE 1 RACER HD UPDATE!",
    link: "https://www.youtube.com/watch?v=0P8FdrU_UQs",
    isShorts: false,
    pubDate: "2020-05-03",
    description: "",
    internalLink: "/0P8FdrU_UQs/",
    shortsThumbnail: "",
    videoThumbnail: "https://img.youtube.com/vi/0P8FdrU_UQs/maxresdefault.jpg",
  },
  {
    videoID: "KeYiW9mYzsI",
    title: "SWE1Racer HD Opening Text Crawl WIP",
    pubDate: "2020-04-27",
    link: "https://www.youtube.com/watch?v=KeYiW9mYzsI",
    thumbnail: "https://i3.ytimg.com/vi/KeYiW9mYzsI/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "xhmwrNNpSSw",
    title: "STAR WARS EPISODE 1 RACER HD MOD (wip)",
    pubDate: "2019-05-30",
    link: "https://www.youtube.com/watch?v=xhmwrNNpSSw",
    thumbnail: "https://i3.ytimg.com/vi/xhmwrNNpSSw/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "erw4R2vTfI4",
    title: "STAR WARS EP1: RACER HD UPGRADE MOD (beta 1 release)",
    pubDate: "2019-10-05",
    link: "https://www.youtube.com/watch?v=erw4R2vTfI4",
    thumbnail: "https://i3.ytimg.com/vi/erw4R2vTfI4/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "bV1GDIZe-OY",
    title: "120",
    pubDate: "2019-06-17",
    link: "https://www.youtube.com/watch?v=bV1GDIZe-OY",
    thumbnail: "https://i3.ytimg.com/vi/bV1GDIZe-OY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "YIwTQvDFq5s",
    title: "STAR WARS RACER - Smush Test 3 - 2019 06 09 12 47 21",
    pubDate: "2019-06-09",
    link: "https://www.youtube.com/watch?v=YIwTQvDFq5s",
    thumbnail: "https://i3.ytimg.com/vi/YIwTQvDFq5s/hqdefault.jpg",
    description: "",
  },
]; */

export const zelda_albw_hd4k_videos_list: LocalVideosList[] = [
  {
    videoID: "rYnPuFUhnpw",
    title: "I'm creating Zelda: A Link Between Worlds 4K/HD",
    pubDate: "2020-06-16",
    link: "https://www.youtube.com/watch?v=rYnPuFUhnpw",
    thumbnail: "https://img.youtube.com/vi/rYnPuFUhnpw/maxresdefault.jpg",
    description: "",
  },
  {
    videoID: "HEBxXwmqoU4",
    title: "I'm creating Zelda: A Link Between Worlds 4K/HD pt2",
    pubDate: "2020-06-23",
    link: "https://www.youtube.com/watch?v=HEBxXwmqoU4",
    thumbnail: "https://img.youtube.com/vi/HEBxXwmqoU4/maxresdefault.jpg",
    description: "",
  },
];

export const bst20_videos_list: LocalVideosList[] = [
  {
    videoID: "RJmtLaxTkpE",
    title: "#BST20 LIVE STREAM - Part 1",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=RJmtLaxTkpE",
    thumbnail: "https://img.youtube.com/vi/RJmtLaxTkpE/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "Zrt5mvObHOQ",
    title: "WHAT IS BIG SHINY TUNES 20?? #BST20",
    pubDate: "2017-10-01",
    link: "https://www.youtube.com/watch?v=Zrt5mvObHOQ",
    thumbnail: "https://img.youtube.com/vi/Zrt5mvObHOQ/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "kDP2zJ5j5tE",
    title: " #BST20 LIVE STREAM - Part 3 ",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=kDP2zJ5j5tE",
    thumbnail: "https://img.youtube.com/vi/kDP2zJ5j5tE/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "wpb7Fax8tK8",
    title:
      "BIG SHINY TUNES 20 (MUCHMUSIC commercial feat. Steve Anthony) #BST20",
    pubDate: "2017-10-01",
    link: "https://www.youtube.com/watch?v=wpb7Fax8tK8",
    thumbnail: "https://img.youtube.com/vi/wpb7Fax8tK8/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "fOn3WjSIcMY",
    title: "Hot Hot Heat - Kid Who Stays in the Picture",
    pubDate: "2016-05-17",
    link: "https://www.youtube.com/watch?v=fOn3WjSIcMY",
    thumbnail: "https://img.youtube.com/vi/fOn3WjSIcMY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "jEOsNtHw5k8",
    title: `Joywave - "DESTRUCTION" (Official Video)`,
    pubDate: "2016-01-13",
    link: "https://www.youtube.com/watch?v=jEOsNtHw5k8",
    thumbnail: "https://img.youtube.com/vi/jEOsNtHw5k8/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "CVQ4qJ2",
    title: "The Strokes - OBLIVIUS (Official Lyric Video)",
    pubDate: "2016-07-12",
    link: "https://www.youtube.com/watch?v=CVQ4qJ2-8wg",
    thumbnail: "https://img.youtube.com/vi/CVQ4qJ2-8wg/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "cgZjGmUmWkw",
    title: "Bully For You - Studio Video",
    pubDate: "2016-05-04",
    link: "https://www.youtube.com/watch?v=cgZjGmUmWkw",
    thumbnail: "https://img.youtube.com/vi/cgZjGmUmWkw/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "waixG1Dhr3w",
    title: "Sum 41 - Fake My Own Death (Official Music Video)",
    pubDate: "2016-06-29",
    link: "https://www.youtube.com/watch?v=waixG1Dhr3w",
    thumbnail: "https://img.youtube.com/vi/waixG1Dhr3w/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "KYp5fmns6fU",
    title: "#BST20 LIVE STREAM - Part 10",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=KYp5fmns6fU",
    thumbnail: "https://img.youtube.com/vi/KYp5fmns6fU/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "Q0oIoR9mLwc",
    title: "Red Hot Chili Peppers - Dark Necessities [Official Music Video]",
    pubDate: "2016-06-17",
    link: "https://www.youtube.com/watch?v=Q0oIoR9mLwc",
    thumbnail: "https://img.youtube.com/vi/Q0oIoR9mLwc/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "UprcpdwuwCg",
    title:
      "twenty one pilots: Heathens (from Suicide Squad: The Album) [OFFICIAL VIDEO]",
    pubDate: "2016-06-21",
    link: "https://www.youtube.com/watch?v=UprcpdwuwCg",
    thumbnail: "https://img.youtube.com/vi/UprcpdwuwCg/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "YWywb9i",
    title: "July Talk - Push + Pull",
    pubDate: "2016-05-20",
    link: "https://www.youtube.com/watch?v=YWywb9i-z7Y",
    thumbnail: "https://img.youtube.com/vi/YWywb9i-z7Y/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "-mMbra94tIo",
    title: "Band Of Skulls - Bodies (Official Video)",
    pubDate: "2016-06-07",
    link: "https://www.youtube.com/watch?v=-mMbra94tIo",
    thumbnail: "https://img.youtube.com/vi/-mMbra94tIo/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "498zUzNGQxY",
    title: "The Kills - Doing It To Death (Official Video)",
    pubDate: "2016-03-01",
    link: "https://www.youtube.com/watch?v=498zUzNGQxY",
    thumbnail: "https://img.youtube.com/vi/498zUzNGQxY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "tolOOwrbFJY",
    title: " #BST20 LIVE STREAM - Part 16 ",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=tolOOwrbFJY",
    thumbnail: "https://img.youtube.com/vi/tolOOwrbFJY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "MXlhQ6Dy-Z8",
    title: "Holy White Hounds - Switchblade (Official Music Video)",
    pubDate: "2016-02-11",
    link: "https://www.youtube.com/watch?v=MXlhQ6Dy-Z8",
    thumbnail: "https://img.youtube.com/vi/MXlhQ6Dy-Z8/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "lIO_2qi32JE",
    title: "The Sheepdogs - Bad Lieutenant - Official Music Video",
    pubDate: "2016-04-12",
    link: "https://www.youtube.com/watch?v=lIO_2qi32JE",
    thumbnail: "https://img.youtube.com/vi/lIO_2qi32JE/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "UpQOoU4vc_Q",
    title:
      "Royal Blood - Where Are You Now? (VINYL: Music From The HBO® Original Series) [Official Audio]",
    pubDate: "2016-04-01",
    link: "https://www.youtube.com/watch?v=UpQOoU4vc_Q",
    thumbnail: "https://img.youtube.com/vi/UpQOoU4vc_Q/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "lic0oCDMfwk",
    title: "blink-182 - Bored To Death (Official Video)",
    pubDate: "2016-06-20",
    link: "https://www.youtube.com/watch?v=lic0oCDMfwk",
    thumbnail: "https://img.youtube.com/vi/lic0oCDMfwk/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "zBp01PqHEu4",
    title: "Cage The Elephant - Cry Baby",
    pubDate: "2016-03-21",
    link: "https://www.youtube.com/watch?v=zBp01PqHEu4",
    thumbnail: "https://img.youtube.com/vi/zBp01PqHEu4/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "RmRqEbJU5s4",
    title: "#BST20 LIVE STREAM - Part 22",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=RmRqEbJU5s4",
    thumbnail: "https://img.youtube.com/vi/RmRqEbJU5s4/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "RlAhWjuvMqk",
    title: "Sam Roberts Band - If You Want It",
    pubDate: "2016-10-28",
    link: "https://www.youtube.com/watch?v=RlAhWjuvMqk",
    thumbnail: "https://img.youtube.com/vi/RlAhWjuvMqk/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "1eWLqX9zrIg",
    title: "Work Shoes - USS (Official Lyric Video)",
    pubDate: "2016-07-29",
    link: "https://www.youtube.com/watch?v=1eWLqX9zrIg",
    thumbnail: "https://img.youtube.com/vi/1eWLqX9zrIg/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "SjBefh8bupY",
    title: `Transformers "Gigantik" by Crash Kings Art Track Music Video | Transformers Official`,
    pubDate: "2016-02-10",
    link: "https://www.youtube.com/watch?v=SjBefh8bupY",
    thumbnail: "https://img.youtube.com/vi/SjBefh8bupY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "N6JbwiVl-8g",
    title: "Billy Talent - Afraid Of Heights (Official Music Video)",
    pubDate: "2016-07-22",
    link: "https://www.youtube.com/watch?v=N6JbwiVl-8g",
    thumbnail: "https://img.youtube.com/vi/N6JbwiVl-8g/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "SUzsih7QJSY",
    title: "Green Day - Still Breathing [Official Music Video]",
    pubDate: "2016-11-07",
    link: "https://www.youtube.com/watch?v=SUzsih7QJSY",
    thumbnail: "https://img.youtube.com/vi/SUzsih7QJSY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "nd_4i8ZLK0Q",
    title: "#BST20 LIVE STREAM - Part 28",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=nd_4i8ZLK0Q",
    thumbnail: "https://img.youtube.com/vi/nd_4i8ZLK0Q/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "kwLh7hKTLLc",
    title: "Big Wreck - Skybunk Marché (Audio)",
    pubDate: "2016-11-18",
    link: "https://www.youtube.com/watch?v=kwLh7hKTLLc",
    thumbnail: "https://img.youtube.com/vi/kwLh7hKTLLc/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "tjSnrDikc4M",
    title: "Iggy Pop - Sunday",
    pubDate: "2016-05-12",
    link: "https://www.youtube.com/watch?v=tjSnrDikc4M",
    thumbnail: "https://img.youtube.com/vi/tjSnrDikc4M/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "hBL005t15Kc",
    title: "Twenty One Pilots - Stressed Out (1Live Session) (Acoustic)",
    pubDate: "2016-02-23",
    link: "https://www.youtube.com/watch?v=hBL005t15Kc",
    thumbnail: "https://img.youtube.com/vi/hBL005t15Kc/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "98rwa9m9KvE",
    title: "#BST20 LIVE STREAM - Part 32",
    pubDate: "2017-10-10",
    link: "https://www.youtube.com/watch?v=98rwa9m9KvE",
    thumbnail: "https://img.youtube.com/vi/98rwa9m9KvE/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "x2Hkhuia4MU",
    title: "Jeremy Meets Jon Williams on The Zone @ 91.3 FM to talk #BST20",
    pubDate: "2017-10-21",
    link: "https://www.youtube.com/watch?v=x2Hkhuia4MU",
    thumbnail: "https://img.youtube.com/vi/x2Hkhuia4MU/hqdefault.jpg",
    description: "",
  },
];

export const emulated_videos_list: LocalVideosList[] = [
  {
    videoID: "tBloyQXP2p0",
    title: "Retroarch Running on Steam Link (Setup Guide)",
    pubDate: "2022-09-27",
    link: "https://www.youtube.com/watch?v=tBloyQXP2p0",
    thumbnail: "https://img.youtube.com/vi/tBloyQXP2p0/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "js708GTKXMo",
    title: "Cemu Setup Wii U Emulator Guide (2019)",
    pubDate: "2022-09-27",
    link: "https://www.youtube.com/watch?v=js708GTKXMo",
    thumbnail: "https://img.youtube.com/vi/js708GTKXMo/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "XQMyJVzJBTQ",
    title: "Emulated E01 - What is Emulated?",
    pubDate: "2022-09-27",
    link: "https://www.youtube.com/watch?v=XQMyJVzJBTQ",
    thumbnail: "https://img.youtube.com/vi/XQMyJVzJBTQ/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "bAuqeECxwKY",
    title: "Emulated Outro",
    pubDate: "2022-09-25",
    link: "https://www.youtube.com/watch?v=bAuqeECxwKY",
    thumbnail: "https://img.youtube.com/vi/bAuqeECxwKY/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "SrTo4XJISyo",
    title: "Short Emulated Intro",
    pubDate: "2022-09-25",
    link: "https://www.youtube.com/watch?v=SrTo4XJISyo",
    thumbnail: "https://img.youtube.com/vi/SrTo4XJISyo/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "K4u2ntcXLY8",
    title: "Long Emulated Intro",
    pubDate: "2022-09-25",
    link: "https://www.youtube.com/watch?v=K4u2ntcXLY8",
    thumbnail: "https://img.youtube.com/vi/K4u2ntcXLY8/hqdefault.jpg",
    description: "",
  },
];

export const zelda_modders_toolkit_videos_list: LocalVideosList[] = [
  {
    videoID: "w_g-IrxZQPE",
    title: "Breath of the Wild Modding - Edit Text (Item Descriptions and Titles)",
    pubDate: "2017-10-26",
    link: "https://www.youtube.com/watch?v=w_g-IrxZQPE",
    thumbnail: "https://img.youtube.com/vi/w_g-IrxZQPE/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "NAXO1INCiVk",
    title: "Breath of the Wild Modding - How to Spawn All Game Assets",
    pubDate: "2017-10-28",
    link: "https://www.youtube.com/watch?v=NAXO1INCiVk",
    thumbnail: "https://img.youtube.com/vi/NAXO1INCiVk/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "fS4BKptutq0",
    title: "Breath of the Wild Modding - Inventory Icon Creation",
    pubDate: "2017-11-10",
    link: "https://www.youtube.com/watch?v=fS4BKptutq0",
    thumbnail: "https://img.youtube.com/vi/fS4BKptutq0/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "uGese1FSjGI",
    title: "Breath of the Wild Modding - Custom Background Music",
    pubDate: "2022-09-06",
    link: "https://www.youtube.com/watch?v=uGese1FSjGI",
    thumbnail: "https://img.youtube.com/vi/uGese1FSjGI/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "CsHIYnaUvGA",
    title: "Breath of the Wild Modding - Sound Effect (.bars)",
    pubDate: "2018-07-12",
    link: "https://www.youtube.com/watch?v=CsHIYnaUvGA",
    thumbnail: "https://img.youtube.com/vi/CsHIYnaUvGA/hqdefault.jpg",
    description: "",
  },
  {
    videoID: "L9wchfVkLBg",
    title: "What is Zelda Modder's Toolkit?",
    pubDate: "2019-02-08",
    link: "https://www.youtube.com/watch?v=L9wchfVkLBg",
    thumbnail: "https://img.youtube.com/vi/L9wchfVkLBg/hqdefault.jpg",
    description: "",
  },
];

export const getRecentYoutubeVideosFromURL = async ({
  feedURL,
}: {
  feedURL: string;
}): Promise<VideoInterface[]> => {
  //const feedURL = `https://api.rss2json.com/v1/api.json?rss_url=https://youtube.com/feeds/videos.xml?channel_id=UCkmUdBwkXwoyejstQfFxgLQ`;
  const URL = "https://corsproxy.io/?" + feedURL;
  try {
    const response = await fetch(URL);

    const xmlData = await response.text();

    // Initialize the XML parser
    const parser = new XMLParser();

    // Parse the XML data
    const parsedData = parser.parse(xmlData);
    console.log("INSIDE GET RECENT");
    console.log(parsedData);

    // Process the data
    const entries = parsedData.feed.entry;
    console.log(entries);

    const processedEntries: VideoInterface[] = [];

    entries.forEach((video: any) => {
      const title: string = video["media:group"]["media:title"];
      const videoID: string = video["yt:videoId"];
      processedEntries.push({
        id: videoID,
        title: title,
        link: "https://www.youtube.com/watch?v=" + videoID,
        isShorts: false, // title.toLowerCase().includes("#shorts"),
        pubDate: video.published.slice(0, 10),
        description: video["media:group"]["media:description"],
        internalLink: "/" + videoID + "/",
        hqVideoThumbnail: "https://img.youtube.com/vi/" + videoID + "/hqdefault.jpg",
        videoThumbnail: "https://img.youtube.com/vi/" + videoID + "/maxresdefault.jpg",
      });
    });

    return processedEntries;
  } catch (error) {
    console.log(error);
    return [];
    //throw new Error(error);
  }
};

export const getRecentYoutubeVideosFromURLFIXED = async ({
  feedURL,
}: {
  feedURL: string;
}): Promise<ApiResponse | null> => {
  //const feedURL = `https://api.rss2json.com/v1/api.json?rss_url=https://youtube.com/feeds/videos.xml?channel_id=UCkmUdBwkXwoyejstQfFxgLQ`;
  const URL = "https://corsproxy.io/?" + encodeURIComponent(feedURL);
  try {
    const response = await extract(URL);

    const xmlData = await response.text();

    // Initialize the XML parser
    const parser = new XMLParser();

    // Parse the XML data
    const parsedData = parser.parse(xmlData);
    console.log(parsedData);

    // Process the data
    const entries = parsedData.feed.entry;
    console.log(entries);
    //const data = await response.json();
    //console.log('inside VIDEOS LIST');
    //console.log(response);
    return response;
  } catch (error) {
    //console.log('basic error in here');
    console.log(error);
    return null;
    //throw new Error(error);
  }
};

/* useEffect(() => {

    const testingInHere = async () => {
      try {
        const URL = 'https://corsproxy.io/?' + encodeURIComponent('https://www.youtube.com/feeds/videos.xml?channel_id=UCkmUdBwkXwoyejstQfFxgLQ');
        const result: any = await extract(URL);
        console.log('after await extract');
        console.log(result);

      } catch (error) {
        console.log(error);
      }
    };

    testingInHere();

  }, []); */

export interface IExtraLife {
  fundraisingGoal: number;
  percentageCompleted: number;
  donationLink: string;
  extraLifePage: string;
  streamIsLive: boolean;
  numMilestones: number;
  sumPledges: number;
  milestones: {
    id: number;
    fundraisingGoal: number;
    description: string;
    isCompleated: boolean;
  }[];
}

export const initialExtraLifeInformation: IExtraLife = {
  fundraisingGoal: 0,
  percentageCompleted: 0,
  donationLink: "",
  extraLifePage: "",
  streamIsLive: false,
  numMilestones: 0,
  sumPledges: 0,
  milestones: [],
};

export const getExtraLifeInformation = async (): Promise<IExtraLife> => {
  const extraLifeInformation =
    "https://www.extra-life.org/api/participants/548633";
  // fundraisingGoal
  // links.donate
  // links.page
  // streamIsLive
  // numMilestones
  // sumPledges

  const extraLifeMilestonesInformation =
    "https://www.extra-life.org/api/participants/548633/milestones";
  // array with json objects
  // fundraisingGoal
  // description
  // do manual isCompleated by checking milestones fundraisingGoal vs total fundraisingGoal
  const finalFundraisingInformation: IExtraLife = initialExtraLifeInformation;
  try {
    const responseExtraLifeInformation = await fetch(extraLifeInformation);
    const dataExtraLifeInformation = await responseExtraLifeInformation.json();
    console.log(dataExtraLifeInformation);
    finalFundraisingInformation.fundraisingGoal =
      dataExtraLifeInformation.fundraisingGoal;
    finalFundraisingInformation.percentageCompleted =
      parseFloat(
        (
          (dataExtraLifeInformation.sumDonations) /
          dataExtraLifeInformation.fundraisingGoal
        ).toFixed(2)
      ) * 100;
    finalFundraisingInformation.donationLink =
      dataExtraLifeInformation.links.donate;
    finalFundraisingInformation.extraLifePage =
      dataExtraLifeInformation.links.page;
    finalFundraisingInformation.streamIsLive =
      dataExtraLifeInformation.streamIsLive;
    finalFundraisingInformation.numMilestones =
      dataExtraLifeInformation.numMilestones;
    finalFundraisingInformation.sumPledges =
      dataExtraLifeInformation.sumDonations;
      console.log(finalFundraisingInformation.percentageCompleted)
    const responseExtraLifeMilestonesInformation = await fetch(
      extraLifeMilestonesInformation
    );
    const dataExtraLifeMilestonesInformation =
      await responseExtraLifeMilestonesInformation.json();
    console.log(dataExtraLifeMilestonesInformation);
    for (let i = 0; i < finalFundraisingInformation.numMilestones; i++) {
      finalFundraisingInformation.milestones.push({
        id: i,
        fundraisingGoal: dataExtraLifeMilestonesInformation[i].fundraisingGoal,
        description: dataExtraLifeMilestonesInformation[i].description,
        isCompleated:
          dataExtraLifeInformation.fundraisingGoal >
            dataExtraLifeInformation.sumDonations
            ? false
            : true,
      });
    }
    //console.log(finalFundraisingInformation);
    return finalFundraisingInformation;
  } catch (error) {
    console.log(error);
    return finalFundraisingInformation;
  }
};

/* export const getRecentYoutubeVideos = async (): Promise<SearchListResponse | null> => {
    try {
        const googleApiYouTube = `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCkmUdBwkXwoyejstQfFxgLQ&order=date&maxResults=6&key=${process.env.GATSBY_API_KEY}`;

        const response = await fetch(googleApiYouTube);
        const data = response.json();

        return data;

    } catch (error) {
        console.log(error);
        //throw new Error(error);
    }

    return null;
}; */

export function unEscape(htmlStr: string) {
  htmlStr = htmlStr.replace(/&lt;/g, "<");
  htmlStr = htmlStr.replace(/&gt;/g, ">");
  htmlStr = htmlStr.replace(/&quot;/g, '"');
  htmlStr = htmlStr.replace(/&#39;/g, "'");
  htmlStr = htmlStr.replace(/&amp;/g, "&");
  return htmlStr;
}

/* TESTING SOMETHING IN HERE !!!!!!! */

export const extract = async (
  url: any,
  options: any = {},
  fetchOptions: any = {}
) => {
  if (!isValid(url)) {
    throw new Error("Input param must be a valid URL");
  }
  const data = await retrieve(url, fetchOptions);
  if (!data.text && !data.json) {
    throw new Error(`Failed to load content from "${url}"`);
  }

  const { type, json, text } = data;

  return type === "json"
    ? extractFromJson(json, options)
    : extractFromXml(text, options);
};

const getopt = (options: any = {}) => {
  const {
    normalization = true,
    descriptionMaxLen = 999999999,
    useISODateFormat = true,
    xmlParserOptions = {},
    getExtraFeedFields = () => ({}),
    getExtraEntryFields = () => ({}),
  } = options;

  return {
    normalization,
    descriptionMaxLen,
    useISODateFormat,
    xmlParserOptions,
    getExtraFeedFields,
    getExtraEntryFields,
  };
};

export const isValid = (url = "") => {
  try {
    const ourl = new URL(url);
    return ourl !== null && ourl.protocol.startsWith("http");
  } catch (err) {
    return false;
  }
};

export const absolutify = (fullUrl = "", relativeUrl = "") => {
  try {
    const result = new URL(relativeUrl, fullUrl);
    return result.toString();
  } catch (err) {
    return "";
  }
};

const blacklistKeys = [
  "CNDID",
  "__twitter_impression",
  "_hsenc",
  "_openstat",
  "action_object_map",
  "action_ref_map",
  "action_type_map",
  "amp",
  "fb_action_ids",
  "fb_action_types",
  "fb_ref",
  "fb_source",
  "fbclid",
  "ga_campaign",
  "ga_content",
  "ga_medium",
  "ga_place",
  "ga_source",
  "ga_term",
  "gs_l",
  "hmb_campaign",
  "hmb_medium",
  "hmb_source",
  "mbid",
  "mc_cid",
  "mc_eid",
  "mkt_tok",
  "referrer",
  "spJobID",
  "spMailingID",
  "spReportId",
  "spUserID",
  "utm_brand",
  "utm_campaign",
  "utm_cid",
  "utm_content",
  "utm_int",
  "utm_mailing",
  "utm_medium",
  "utm_name",
  "utm_place",
  "utm_pubreferrer",
  "utm_reader",
  "utm_social",
  "utm_source",
  "utm_swu",
  "utm_term",
  "utm_userid",
  "utm_viz_id",
  "wt_mc_o",
  "yclid",
  "WT.mc_id",
  "WT.mc_ev",
  "WT.srch",
  "pk_source",
  "pk_medium",
  "pk_campaign",
];

const purify = (url: any) => {
  try {
    const pureUrl = new URL(url);

    blacklistKeys.forEach((key) => {
      pureUrl.searchParams.delete(key);
    });

    return pureUrl.toString().replace(pureUrl.hash, "");
  } catch (err) {
    return null;
  }
};

const profetch = async (url: any, proxy: any = {}) => {
  const { target, headers = {} } = proxy;
  const res = await fetch(target + encodeURIComponent(url), {
    headers,
  });
  return res;
};

export const retrieve = async (url: any, options: any = {}) => {
  const {
    headers = {
      "user-agent":
        "Mozilla/5.0 (X11; Linux x86_64; rv:108.0) Gecko/20100101 Firefox/108.0",
    },
    proxy = null,
  } = options;

  const res = proxy
    ? await profetch(url, proxy)
    : await fetch(url, { headers });

  const status = res.status;
  if (status >= 400) {
    throw new Error(`Request failed with error code ${status}`);
  }
  const contentType: any = res.headers.get("content-type");
  const text = await res.text();

  if (/(\+|\/)(xml|html)/.test(contentType)) {
    return { type: "xml", text: text.trim(), status, contentType };
  }

  if (/(\+|\/)json/.test(contentType)) {
    try {
      const data = JSON.parse(text);
      return { type: "json", json: data, status, contentType };
    } catch (err) {
      throw new Error("Failed to convert data to JSON object");
    }
  }
  throw new Error(`Invalid content type: ${contentType}`);
};

export const extractFromJson = (json: any, options: any = {}) => {
  return parseJsonFeed(json, getopt(options));
};

export const extractFromXml = (xml: any, options: any = {}) => {
  if (!validate(xml)) {
    throw new Error("The XML document is not well-formed");
  }

  const opts = getopt(options);

  const data = xml2obj(xml, opts.xmlParserOptions);
  //console.log('inside extractFromXml');
  //console.log(data);
  //console.log(isAtom(data));
  return isRSS(data)
    ? parseRssFeed(data, opts)
    : isAtom(data)
      ? parseAtomFeed(data, opts)
      : null;
};

const transform = (item: any, options: any) => {
  const { useISODateFormat, descriptionMaxLen, getExtraEntryFields } = options;
  //console.log('inside transform');
  //console.log(item);
  //console.log('inside transform - finding single description');
  //console.log(item["media:group"]["media:description"]);
  const {
    id = "",
    title = "",
    url: link = "",
    date_published: pubDate = "",
    summary = "",
    content_html: htmlContent = "",
    content_text: textContent = "",
  } = item;

  const published = useISODateFormat ? toISODateString(pubDate) : pubDate;
  const extraFields = getExtraEntryFields(item);

  const entry = {
    id: getEntryId(id, link, pubDate),
    title,
    link: item["link"]["@_href"],
    published: item["published"],
    description: item["media:group"]["media:description"], //buildDescription(textContent || htmlContent || summary, descriptionMaxLen),
  };

  return {
    ...entry,
    ...extraFields,
  };
};

const parseJson = (data: any, options: any) => {
  const { normalization, getExtraFeedFields } = options;

  if (!normalization) {
    return data;
  }

  const {
    title = "",
    home_page_url: homepageUrl = "",
    description = "",
    language = "",
    items: item = [],
  } = data;

  const extraFields = getExtraFeedFields(data);

  const items = isArray(item) ? item : [item];

  return {
    title,
    link: purify(homepageUrl),
    description,
    language,
    published: "",
    generator: "",
    ...extraFields,
    entries: items.map((item: any) => {
      return transform(item, options);
    }),
  };
};

const parseJsonFeed = (data: any, options = {}) => {
  return parseJson(data, options);
};

const toISODateString = (dstr: any) => {
  try {
    return dstr ? new Date(dstr).toISOString() : "";
  } catch (err) {
    return "";
  }
};

const buildDescription = (val: any, maxlen: any) => {
  const stripped = stripTags(String(val));
  //console.log('inside buildDescription');
  //console.log(stripped);
  return truncate(stripped, maxlen).replace(/\n+/g, " ");
};

const getText = (val: any) => {
  const txt = isObject(val)
    ? val._text || val["#text"] || val._cdata || val.$t
    : val;
  return txt ? decode(String(txt).trim()) : "";
};

const getLink = (val: any = [], id: any = "") => {
  if (id && isValid(id)) {
    return id;
  }
  if (
    isObject(id) &&
    hasProperty(id, "@_isPermaLink") &&
    id["@_isPermaLink"] === "true"
  ) {
    return getText(id);
  }
  const getEntryLink = (links: any) => {
    const items = links.map((item: any) => {
      return getLink(item);
    });
    return items.length > 0 ? items[0] : "";
  };
  return isString(val)
    ? getText(val)
    : isObject(val) && hasProperty(val, "href")
      ? getText(val.href)
      : isObject(val) && hasProperty(val, "@_href")
        ? getText(val["@_href"])
        : isObject(val) && hasProperty(val, "@_url")
          ? getText(val["@_url"])
          : isObject(val) && hasProperty(val, "_attributes")
            ? getText(val._attributes.href)
            : isArray(val)
              ? getEntryLink(val)
              : "";
};

const getPureUrl = (url: any, id = "") => {
  const link = getLink(url, id);
  return link ? purify(link) : "";
};

const hash = (str: any) =>
  Math.abs(
    str
      .split("")
      .reduce((s: any, c: any) => (Math.imul(31, s) + c.charCodeAt(0)) | 0, 0)
  ).toString(36);

const getEntryId = (id: any, url: any, pubDate: any) => {
  return id
    ? getText(id)
    : hash(getPureUrl(url)) + "-" + new Date(pubDate).getTime();
};

const getEnclosure = (val: any) => {
  const url = hasProperty(val, "@_url") ? val["@_url"] : "";
  const type = hasProperty(val, "@_type") ? val["@_type"] : "";
  const length = Number(hasProperty(val, "@_length") ? val["@_length"] : 0);
  return !url || !type
    ? null
    : {
      url,
      type,
      length,
    };
};

const getCategory = (v: any) => {
  return isObject(v)
    ? {
      text: getText(v),
      domain: v["@_domain"],
    }
    : v;
};

const getOptionalTags = (val: any, key: any) => {
  if (key === "source") {
    return {
      text: getText(val),
      url: getLink(val),
    };
  }
  if (key === "category") {
    return isArray(val) ? val.map(getCategory) : getCategory(val);
  }
  if (key === "enclosure") {
    return getEnclosure(val);
  }
  return val;
};

const isRSS = (data: any = {}) => {
  return hasProperty(data, "rss") && hasProperty(data.rss, "channel");
};

export const isAtom = (data: any = {}) => {
  return hasProperty(data, "feed") && hasProperty(data.feed, "entry");
};

export const validate = (xml: any) => {
  return !isString(xml) || !xml.length
    ? false
    : XMLValidator.validate(xml) === true;
};

export const xml2obj = (xml = "", extraOptions = {}) => {
  const options = {
    ...extraOptions,
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
  };
  const parser = new XMLParser(options);
  const jsonObj = parser.parse(xml);
  return jsonObj;
};

const flatten = (feed: any) => {
  const { title = "", link = "", item } = feed;

  const items = isArray(item) ? item : [item];
  const entries = items.map((entry: any) => {
    const { id, title = "", link = "" } = entry;

    const item = {
      ...entry,
      title: getText(title),
      link: getPureUrl(link, id),
    };

    const txtTags = "guid description source".split(" ");

    txtTags.forEach((key) => {
      if (hasProperty(entry, key)) {
        item[key] = getText(entry[key]);
      }
    });

    const optionalProps = "source category enclosure author image".split(" ");
    optionalProps.forEach((key) => {
      if (hasProperty(item, key)) {
        entry[key] = getOptionalTags(item[key], key);
      }
    });

    return item;
  });

  const output = {
    ...feed,
    title: getText(title),
    link: getPureUrl(link),
    item: isArray(item) ? entries : entries[0],
  };
  return output;
};

const parseRss = (data: any, options: any = {}) => {
  const { normalization, getExtraFeedFields } = options;

  if (!normalization) {
    return flatten(data.rss.channel);
  }
  //console.log('inside parseRss');
  //console.log(data.rss.channel);
  const {
    title = "",
    link = "",
    description = "",
    generator = "",
    language = "",
    lastBuildDate = "",
    item = [],
  } = data.rss.channel;

  const extraFields = getExtraFeedFields(data.rss.channel);

  const items = isArray(item) ? item : [item];

  const published = options.useISODateFormat
    ? toISODateString(lastBuildDate)
    : lastBuildDate;

  return {
    title: getText(title),
    link: getPureUrl(link),
    description,
    language,
    generator,
    published,
    ...extraFields,
    entries: items.map((item: any) => {
      return transform(item, options);
    }),
  };
};

const parseRssFeed = (data: any, options = {}) => {
  return parseRss(data, options);
};

const parseAtom = (data: any, options: any = {}) => {
  const { normalization, getExtraFeedFields } = options;
  //console.log('inside parseAtom');
  //console.log(data.feed);
  if (!normalization) {
    return flatten(data.feed);
  }
  const {
    id = "",
    title = "",
    link = "",
    subtitle = "",
    generator = "",
    language = "",
    updated = "",
    entry: item = [],
  } = data.feed;

  const extraFields = getExtraFeedFields(data.feed);

  const items = isArray(item) ? item : [item];

  const published = options.useISODateFormat
    ? toISODateString(updated)
    : updated;

  return {
    title: getText(title),
    link: getPureUrl(link, id),
    description: subtitle,
    language,
    generator,
    published,
    ...extraFields,
    entries: items.map((item: any) => {
      return transform(item, options);
    }),
  };
};

export const parseAtomFeed = (data: any, options: any = {}) => {
  //console.log('inside parseAtomFeed');
  //console.log(data);
  return parseAtom(data, options);
};
